import { bool, func, object, oneOf, shape, string } from "prop-types";
import { createRef, useEffect, useState } from "react";
import Button from "../Button/Button.jsx";
import Icon from "../Icon/Icon.jsx";
import renderDiagramAgnostic from "./renderScripts/renderDiagramAgnostic.js";
import renderDiagramExpanded from "./renderScripts/renderDiagramExpanded.js";
import renderDiagramSingle from "./renderScripts/renderDiagramSingle.js";

const propTypes = {
  callToActionText: string,
  country: object,
  handleSelect: func,
  isExpanded: bool,
  link: shape({ url: string, text: string }),
  type: oneOf(["agnostic", "single", "multiple"]).isRequired,
};

const StuntDriversDiagram = (props) => {
  const {
    callToActionText,
    country,
    handleSelect,
    isExpanded,
    link,
    type,
  } = props;

  const [isInitialized, toggleInitialized] = useState(false);
  const container = createRef();

  useEffect(() => {
    if (isInitialized || !country) return;

    const { categories } = country;

    if (country && !country.id) {
      // Render agnostic diagram
      renderDiagramAgnostic({
        el: container.current,
        diagramData: categories,
        handleSelect,
      });
    } else if (isExpanded) {
      renderDiagramExpanded({
        country: country,
        el: container.current,
        diagramData: categories,
        handleSelect,
      });
    } else {
      renderDiagramSingle({
        country: country,
        el: container.current,
        diagramData: categories,
        handleSelect,
      });
    }

    toggleInitialized(!isInitialized);
  }, [container, country, handleSelect, isExpanded, isInitialized]);

  return (
    <div className="stunt-drivers__diagram">
      <div className="stunt-drivers__diagram-container" ref={container} />
      {type === "single" && link && (
        <div className="stunt-drivers__link">
          <h3 className="stunt-drivers__link-title h5">Learn More</h3>
          {callToActionText && (
            <h4 className="stunt-drivers__cta h2">{callToActionText}</h4>
          )}
          <Button
            as="a"
            href={link.url}
            className="stunt-drivers__button btn--tertiary"
            icon={<Icon iconName="white-caret" />}
          >
            {link.text}
          </Button>
        </div>
      )}
    </div>
  );
};

StuntDriversDiagram.propTypes = propTypes;
export default StuntDriversDiagram;
